import React from "react";
import { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { Link } from "react-router-dom";
import "../../assets/style/header.css";

const Header = ({ toggleSidebar }) => {
    const { logout, isLogged } = useContext(AuthContext);

    return (
        <>
            <nav className="navbar">
                <div className="left-section">
                    <button className="btn-toggle d-md-none" onClick={toggleSidebar}>☰</button>
                    <Link to="/" className="navbar-brand d-flex align-items-center">
                        <div className="content-logo">
                            <img src="/logo.png" alt="Logo" className="animated-logo" />
                        </div>
                        <span className="brand-text">Net Track</span>
                    </Link>
                </div>

                <button className="btn-custom" onClick={logout}>
                    {isLogged ? "Déconnexion" : "Connexion"}
                </button>
            </nav>
        </>
    );
};

export default Header;
